import { useTranslation } from "react-i18next";
import type { AuthMode } from "@/features/auth/hooks/auth/useLoginAuth";

interface LoginHeaderProps {
  mode: AuthMode;
}

export default function LoginHeader({ mode }: LoginHeaderProps) {
  const { t } = useTranslation(["auth"]);
  return (
    <div className="mb-8 text-left">
      <h1 className="text-3xl font-semibold tracking-tight text-[var(--foreground)] sm:text-4xl">
        {mode === "login" && t("auth:login.title")}
        {mode === "register" && t("auth:register.title")}
        {mode === "reset" && t("auth:reset.title")}
      </h1>
      <p className="mt-3 text-sm leading-6 text-[var(--muted-foreground)] sm:text-base">
        {mode === "login" && t("auth:login.subtitle")}
        {mode === "register" && t("auth:register.subtitle")}
        {mode === "reset" && t("auth:reset.subtitle")}
      </p>
    </div>
  );
}
